import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Menu, X, Phone, KeyRound } from "lucide-react";
import { LOGO_URL } from "@/lib/api";

const LINKS = [
  { href: "#pakalpojumi", label: "Pakalpojumi" },
  { href: "#par-mums", label: "Par mums" },
  { href: "#galerija", label: "Galerija" },
  { href: "#pieteikums", label: "Pieteikums" },
  { href: "#kontakti", label: "Kontakti" },
];

export const Nav = ({ phone }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 1.9, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled ? "border-b border-white/10 bg-[#08080a]/85 backdrop-blur-xl" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-[1500px] items-center justify-between px-5 py-3 sm:px-10">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3">
          <img src={LOGO_URL} alt="TURBOLUX AUTOSERVISS" className="h-9 w-auto object-contain sm:h-11" />
        </a>

        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="link-underline font-mono-t text-[11px] uppercase tracking-[0.22em] text-slate-300 transition-colors hover:text-white"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          <a
            href={`tel:${(phone || "").replace(/\s/g, "")}`}
            data-testid="nav-phone"
            className="hidden items-center gap-2 font-mono-t text-xs text-slate-300 hover:text-white sm:flex"
          >
            <Phone className="h-3.5 w-3.5 text-rose-500" />
            {phone}
          </a>
          <Link
            to="/admin/login"
            data-testid="nav-admin-link"
            className="hidden h-9 w-9 items-center justify-center border border-white/15 text-slate-400 transition-colors hover:border-rose-500 hover:text-rose-400 sm:flex"
            title="Admin"
          >
            <KeyRound className="h-4 w-4" />
          </Link>
          <a
            href="#pieteikums"
            data-testid="nav-cta"
            className="group relative overflow-hidden border border-rose-600/70 bg-rose-600/10 px-4 py-2 font-head text-sm font-bold uppercase tracking-wide text-rose-300 transition-colors hover:bg-rose-600 hover:text-white sm:px-6"
          >
            Pieteikt auto
          </a>
          <button
            onClick={() => setOpen((o) => !o)}
            data-testid="nav-mobile-toggle"
            className="flex h-9 w-9 items-center justify-center border border-white/15 text-slate-200 lg:hidden"
          >
            {open ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
          </button>
        </div>
      </div>

      {open && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          className="overflow-hidden border-t border-white/10 bg-[#08080a]/98 backdrop-blur-xl lg:hidden"
        >
          <div className="flex flex-col px-6 py-4">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="border-b border-white/5 py-3 font-head text-lg uppercase text-slate-200"
              >
                {l.label}
              </a>
            ))}
            <Link to="/admin/login" className="py-3 font-mono-t text-xs uppercase tracking-widest text-rose-400">
              Admin panelis
            </Link>
          </div>
        </motion.div>
      )}
    </motion.header>
  );
};
